import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Box, Link as MuiLink, Typography, styled } from "@mui/material";
import Header from "../componentsPeopletech/Header";
import BarraApp from "../componentsPeopletech/Barraaps";
import ServicesCircles from "../componentsPeopletech/ServicesCircles";
import Footer from "../componentsPeopletech/Footer/Footer";
import ContactSection from "../componentsPeopletech/ContactSection";

const WA = (msg) =>
  `https://wa.me/34666286672?text=${encodeURIComponent(msg)}`;

const BackgroundVideoContainer = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: -1,
  overflow: "hidden",
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: 1,
  },
});

const Video = styled("video")({
  position: "absolute",
  top: "50%",
  left: "50%",
  minWidth: "100%",
  minHeight: "100%",
  width: "auto",
  height: "auto",
  transform: "translate(-50%, -50%)",
  filter: "blur(5px)",
  objectFit: "cover",
  zIndex: 0,
  opacity: 1,
});

const ContentWrapper = styled(Box)({
  position: "relative",
  zIndex: 1,
  backgroundColor: "transparent",
});

const academyItems = [
  { key: "chatgpt", titleKey: "academy.class1Title", descriptionKey: "academy.class1Desc", msg: "Hola, quiero clase de ChatGPT y Claude a 15 €/h" },
  { key: "n8n", titleKey: "academy.class2Title", descriptionKey: "academy.class2Desc", msg: "Hola, quiero clase de n8n a 15 €/h" },
  { key: "cursor", titleKey: "academy.class3Title", descriptionKey: "academy.class3Desc", msg: "Hola, quiero clase de Cursor / Claude Code a 15 €/h" },
  { key: "agents", titleKey: "academy.class4Title", descriptionKey: "academy.class4Desc", msg: "Hola, quiero clase de agentes de IA a 15 €/h" },
  { key: "marketing", titleKey: "academy.class5Title", descriptionKey: "academy.class5Desc", msg: "Hola, quiero clase de IA para marketing a 15 €/h" },
  { key: "pyme", titleKey: "academy.class6Title", descriptionKey: "academy.class6Desc", msg: "Hola, quiero clase de IA para mi pyme a 15 €/h" },
];

const AcademyPeople = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || "es";
  const baseUrl = "https://www.peoplefortech.com";
  const pageUrl = `${baseUrl}/academy`;

  return (
    <>
      <Helmet>
        <title>{t("academy.seoTitle")}</title>
        <meta name="description" content={t("academy.seoDescription")} />
        <link rel="canonical" href={pageUrl} />
        <html lang={currentLang} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content={t("academy.seoTitle")} />
        <meta property="og:description" content={t("academy.seoDescription")} />
      </Helmet>
      <BackgroundVideoContainer>
        <Video autoPlay loop muted playsInline src="/18192389-hd_1920_1080_60fps.mp4">
          Tu navegador no soporta la reproducción de videos.
        </Video>
      </BackgroundVideoContainer>
      <ContentWrapper>
        <BarraApp />
        <Header
          title={t("academy.title")}
          subtitle={t("academy.subtitle")}
          cta={t("academy.ctaWhatsapp")}
          ctaHref={WA("Hola, quiero reservar una clase de IA a 15 €/h")}
          ctaExternal
        />
        <ServicesCircles
          items={academyItems}
          onItemClick={(item) => window.open(WA(item.msg), "_blank", "noopener,noreferrer")}
        />
        <Box sx={{ textAlign: "center", px: 2, mb: 2 }}>
          <Typography variant="body1" sx={{ color: "#111", mb: 1 }}>
            {t("academy.priceBanner")}
          </Typography>
          <MuiLink
            href={WA("Hola, quiero la primera toma de 20 min sin coste")}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ fontWeight: 700, color: "#1e2a5a" }}
          >
            {t("academy.priceLink")}
          </MuiLink>
        </Box>
        <ContactSection />
        <Footer />
      </ContentWrapper>
    </>
  );
};

export default AcademyPeople;
